import { create } from "zustand";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

interface ChatStore {
  isOpen: boolean;
  messages: ChatMessage[];
  currentZone: string | null;
  isStreaming: boolean;
  askedPresets: string[];
  toggleChat: () => void;
  openChat: () => void;
  closeChat: () => void;
  setCurrentZone: (zone: string | null) => void;
  addUserMessage: (content: string) => void;
  addAssistantMessage: (content: string) => void;
  appendToLastAssistant: (token: string) => void;
  setStreaming: (streaming: boolean) => void;
  markPresetAsked: (preset: string) => void;
  clearMessages: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  isOpen: false,
  messages: [],
  currentZone: null,
  isStreaming: false,
  askedPresets: [],

  toggleChat: () => set((state) => ({ isOpen: !state.isOpen })),
  openChat: () => set({ isOpen: true }),
  closeChat: () => set({ isOpen: false }),

  setCurrentZone: (zone) => set({ currentZone: zone }),

  addUserMessage: (content) =>
    set((state) => ({
      messages: [...state.messages, { role: "user", content }],
    })),

  addAssistantMessage: (content) =>
    set((state) => ({
      messages: [...state.messages, { role: "assistant", content }],
    })),

  appendToLastAssistant: (token) =>
    set((state) => {
      const msgs = [...state.messages];
      const last = msgs[msgs.length - 1];
      if (last && last.role === "assistant") {
        msgs[msgs.length - 1] = { ...last, content: last.content + token };
      }
      return { messages: msgs };
    }),

  setStreaming: (streaming) => set({ isStreaming: streaming }),

  markPresetAsked: (preset) =>
    set((state) =>
      state.askedPresets.includes(preset)
        ? state
        : { askedPresets: [...state.askedPresets, preset] }
    ),

  clearMessages: () => set({ messages: [] }),
}));
